import { Modal } from "prosperita-dumbo-react";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useLoading from "~/hooks/useLoading";
import useOperation from "~/hooks/useOperation";
import {
  deleteOperationInvolvedAPI,
  getOperationDetailAPI,
} from "~/services/api/operations";
import {
  deleteSubscriberInvolvedAPI,
  getSubscriberAPI,
} from "~/services/api/subscriber";

const DeleteInvolved = () => {
  const {
    deleteInvolvedData,
    setDeleteInvolvedData,
    setSubscriber,
    setOperationDetails,
  } = useOperation();
  const { setLoading } = useLoading();
  const { id, uuid } = useParams();

  const handleClose = useCallback(() => {
    setDeleteInvolvedData(null);
  }, [setDeleteInvolvedData]);

  const fetchRemoveInvolved = useCallback(async () => {
    setLoading(true);

    try {
      if (id) {
        await deleteSubscriberInvolvedAPI(String(deleteInvolvedData?.uuid));
        setDeleteInvolvedData(null);
        toast.success("Envolvido removido com sucesso!");
        setLoading(false);

        const { data } = await getSubscriberAPI(String(id));

        setSubscriber(data.payload);
        setLoading(false);
      } else {
        await deleteOperationInvolvedAPI(String(deleteInvolvedData?.uuid));
        setDeleteInvolvedData(null);
        toast.success("Envolvido removido com sucesso!");

        const { data } = await getOperationDetailAPI(String(uuid));
        setOperationDetails(data.payload);

        setLoading(false);
      }

      setLoading(false);
    } catch (e) {
      console.log(e);

      toast.error(
        "Não foi possível remover o envolvido! Tente novamente mais tarde"
      );
    }
  }, [
    setLoading,
    setDeleteInvolvedData,
    id,
    setOperationDetails,
    uuid,
    setSubscriber,
    deleteInvolvedData,
  ]);

  return (
    <Modal
      height={"468px"}
      width="960px"
      background="#f4f4f4"
      label={<h4>Remover envolvido</h4>}
      radius
      onClose={() => {
        handleClose();
      }}
      open={deleteInvolvedData !== null}
      buttons={[
        { kind: "ghost", label: "Cancelar", onClick: () => handleClose() },
        {
          kind: "primary",
          label: "Sim, remover",
          onClick: () => fetchRemoveInvolved(),
        },
      ]}
    >
      <div style={{ padding: "50px" }}>
        <h3>
          Deseja realmente remover o envolvido {deleteInvolvedData?.name} ?{" "}
        </h3>
      </div>
    </Modal>
  );
};
export default DeleteInvolved;
